import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { combineLatest, filter, map } from 'rxjs';
import { isPresent } from '@mode/shared/util-js';

import { DatasetFacade } from '@mode/dataset/contract';
import { GithubFacade } from '@mode/github/contract';
import * as GithubSelectors from './github.selectors';

@Injectable()
export class GithubFacadeService extends GithubFacade {
  override readonly canSyncToGithub$ = combineLatest([
    this.store.select(GithubSelectors.isAuthorizedToSyncToGithub),
    this.datasetFacade.isSheetDataset$,
  ]).pipe(map(([isAuthorizedToSyncToGithub, isSheetDataset]) => isAuthorizedToSyncToGithub && !isSheetDataset));

  override readonly githubLink$ = combineLatest([
    this.store.select(GithubSelectors.githubLink),
    this.datasetFacade.isSheetDataset$,
  ]).pipe(map(([githubLink, isSheetDataset]) => (isSheetDataset ? null : githubLink)));

  override readonly lastSynchedAt$ = this.store.select(GithubSelectors.lastSynchedAt).pipe(filter(isPresent));

  override readonly hasUnsyncedChanges$ = this.store.select(GithubSelectors.hasUnsyncedChanges);

  constructor(
    private readonly store: Store,
    private readonly datasetFacade: DatasetFacade
  ) {
    super();
  }

  public override dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
